module.exports = new __parcel__URL__("floor-tom_8.20433cf0.mp3").toString();